import SuspendedLicenseLawyers from '../../containers/Services/SuspendedLicenseLawyers';
export default SuspendedLicenseLawyers;
